import { useNavigate } from "react-router-dom";
import { ChevronDown, LogOut, Settings, Shield } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/context/AuthContext";

export function UserMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  if (!user) return null;
  const initials = user.name.split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center gap-2 rounded-full border border-slate-200 bg-white py-1 pl-1 pr-2.5 transition-colors hover:border-slate-300" data-testid="user-menu-dropdown-button">
          <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#1B2A4A] text-[11px] font-bold text-amber-400">{initials}</span>
          <span className="hidden max-w-[140px] truncate text-sm font-medium text-slate-700 sm:block">{user.name}</span>
          <ChevronDown className="h-3.5 w-3.5 text-slate-400" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-60 bg-white">
        <DropdownMenuLabel className="font-normal">
          <p className="text-sm font-semibold text-slate-900" data-testid="user-menu-name">{user.name}</p>
          <p className="truncate text-xs text-slate-500" data-testid="user-menu-email">{user.email}</p>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={() => navigate("/configuracion")} className="cursor-pointer" data-testid="user-menu-settings-link">
          <Settings className="mr-2 h-4 w-4" /> Configuración
        </DropdownMenuItem>
        {user.role === "admin" && (
          <DropdownMenuItem onSelect={() => navigate("/admin")} className="cursor-pointer" data-testid="user-menu-admin-link">
            <Shield className="mr-2 h-4 w-4" /> Panel admin
          </DropdownMenuItem>
        )}
        <DropdownMenuItem onSelect={handleLogout} className="cursor-pointer text-rose-600 focus:text-rose-700" data-testid="user-menu-logout-button">
          <LogOut className="mr-2 h-4 w-4" /> Cerrar sesión
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
